import { css } from '@emotion/react';

export const planEditorStyles = {
  gridWrapper: css({
    overflow: 'auto',
    maxHeight: '70vh',
    border: '1px solid #f0f0f0',
    borderRadius: 8,
  }),
  plotViewport: css({
    width: 450,
    height: 450,
    maxWidth: '100%',
    maxHeight: '70vh',
    border: '1px solid #d9d9d9',
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.02)',
  }),
  managementLayout: css({
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',
  }),
  workspaceLayout: css({
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',
  }),
  workspaceGrid: css({
    flexShrink: 0,
  }),
  workspaceSidebar: css({
    flexShrink: 0,
  }),
  managementGrid: css({
    flexShrink: 0,
  }),
  managementSidebar: css({
    flexShrink: 0,
  }),
  entityHint: css({
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: 8,
    padding: '4px 8px',
    background: 'rgba(0, 0, 0, 0.75)',
    color: '#fff',
    borderRadius: 4,
    fontSize: 12,
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 1000,
  }),
};
